import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

export const policyAcceptedBeacon = (action) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.TOS,
  eventName: EVENT_NAMES.POLICY_ACCEPTED,
  label: action.payload.policyName,
});
